/**
 * Remote control settings plugin.
 */

'use strict';

/* eslint max-lines-per-function: 0 */
/* eslint quote-props: 0 */

var Emitter        = require('cjs-emitter'),
    keys           = require('stb-keys'),
    gettextWrapper = require('mag-gettext'),
    volumeWrapper  = require('./volume.wrapper'),

    provider = new Emitter(),

    correction = 0,
    correctionReady = 0,
    step = 5,

    api, audioVolume, mute, gettext;


function checkSelected ( options, select ) {
    var index;

    for ( index = 0; index < options.length; index++ ) {
        if ( options[index].value === select ) {
            options[index].selected = true;
            break;
        }
    }
}


function buildList () {
    var data = {};

    switch ( core.device.model ) {
        case 'emulator_stb':
        case 'AndroidSTB':
            data = {
                id: 'audio',
                name: gettext('Audio'),
                description: gettext('Setting audio parameters'),
                icon: 'theme-icon-volume',
                sections: [
                    {
                        id: 'audio',
                        name: gettext('Audio'),
                        description: gettext('Setting audio parameters'),
                        icon: 'theme-icon-volume'
                    }
                ],
                options: [
                    {
                        id: 'audioOutputMode',
                        name:  gettext('Audio Output Mode'),
                        description: gettext('Select the sound output mode: Mono, Stereo, Lt / Rt, etc.'),
                        icon: 'theme-icon-equalizer',
                        render: api.renders.popupSelect,
                        saveImmediate: true,
                        environment: {
                            'audio_stereo_out_mode': 'STEREO'
                        },
                        prepareForRender: function ( environment, callback ) {
                            var select = environment['audio_stereo_out_mode'],
                                options = [
                                    {value: 'STEREO', name: gettext('Stereo')},
                                    {value: 'MONO', name: gettext('Mono')},
                                    {value: 'MONO_LEFT', name: gettext('Mono Left')},
                                    {value: 'MONO_RIGHT', name: gettext('Mono Right')},
                                    {value: 'LT_RT', name: 'Lt/Rt'}
                                ];

                            checkSelected(options, select);
                            callback(options);
                        },
                        prepareForSave: function ( value, callback ) {
                            var audioModes = {
                                STEREO: 0,
                                MONO: 1,
                                MONO_LEFT: 2,
                                MONO_RIGHT: 3,
                                LT_RT: 4
                            };

                            gSTB.SetStereoMode(audioModes[value]);
                            this.environment['audio_stereo_out_mode'] = value;
                            callback();
                        },
                        getter: api.getters.environment,
                        saver: api.savers.environment,
                        parent: 'audio'
                    },

                    //advanced
                    {
                        id: 'audioSPDIF',
                        name:  gettext('SPDIF Mode'),
                        description: '',
                        icon: 'theme-icon-volume',
                        render: api.renders.popupSelect,
                        saveImmediate: true,
                        advanced: true,
                        environment: {
                            'audio_spdif_mode': 'BITSTEAM'
                        },
                        prepareForRender: function ( environment, callback ) {
                            var select = environment['audio_spdif_mode'] || 'BITSTEAM',
                                options = [
                                    {value: 'PCM', name: 'PCM'},
                                    {value: 'BITSTEAM', name: 'Bitstream'}
                                ];

                            checkSelected(options, select);
                            callback(options);
                        },
                        prepareForSave: function ( value, callback ) {
                            this.environment['audio_spdif_mode'] = value;
                            gSTB.SetupSPdif(value === 'PCM' ? 1 : 2);
                            callback();
                        },
                        getter: api.getters.environment,
                        saver: api.savers.environment,
                        parent: 'audio'
                    },
                    {
                        id: 'audioHDMI',
                        name:  gettext('HDMI Audio'),
                        description: '',
                        icon: 'theme-icon-volume',
                        render: api.renders.popupSelect,
                        saveImmediate: true,
                        advanced: true,
                        environment: {
                            'audio_hdmi_audio_mode': 'PCM'
                        },
                        prepareForRender: function ( environment, callback ) {
                            var select = environment['audio_hdmi_audio_mode'] || 'PCM',
                                options = [
                                    {value: 'PCM', name: 'PCM'},
                                    {value: 'SPDIF', name: 'SPDIF'}
                                ];

                            checkSelected(options, select);
                            callback(options);
                        },
                        prepareForSave: function ( value, callback ) {
                            this.environment['audio_hdmi_audio_mode'] = value;
                            gSTB.SetHDMIAudioOut(value === 'SPDIF' ? 1 : 0);
                            callback();
                        },
                        getter: api.getters.environment,
                        saver: api.savers.environment,
                        parent: 'audio'
                    }
                ],
                content: []
            };
            break;
        default:
            data = {
                id: 'audio',
                name: gettext('Audio'),
                description: gettext('Setting audio parameters'),
                icon: 'theme-icon-volume',
                sections: [
                    {
                        id: 'audio',
                        name: gettext('Audio'),
                        description: gettext('Setting audio parameters'),
                        icon: 'theme-icon-volume'
                    }
                ],
                options: [
                    {
                        id: 'audioVolume',
                        name: gettext('Initial volume level'),
                        description: gettext('Setting the initial volume level with which playback will be performed after switch on'),
                        icon: 'theme-icon-volume',
                        render: api.renders.rangeInput,
                        saveImmediate: true,
                        config: {
                            min: 0,
                            max: 100,
                            step: 5
                        },
                        environment: {
                            'audio_initial_volume': 100
                        },
                        prepareForRender: function ( environment, callback ) {
                            var value = 100;

                            try {
                                if ( environment['audio_initial_volume'] ) {
                                    value = parseInt(environment['audio_initial_volume'], 10);
                                }
                            } catch ( error ) {
                                value = 100;
                            }

                            callback(value);
                        },
                        prepareForSave: function ( value, callback ) {
                            this.environment['audio_initial_volume'] = value;
                            callback();
                        },
                        getter: api.getters.environment,
                        saver: api.savers.environment,
                        parent: 'audio'
                    },
                    {
                        id: 'audioOutputMode',
                        name:  gettext('Audio Output Mode'),
                        description: gettext('Select the sound output mode: Mono, Stereo, Lt / Rt, etc.'),
                        icon: 'theme-icon-equalizer',
                        render: api.renders.popupSelect,
                        saveImmediate: true,
                        environment: {
                            'audio_stereo_out_mode': 'STEREO'
                        },
                        prepareForRender: function ( environment, callback ) {
                            var select = environment['audio_stereo_out_mode'],
                                options = [
                                    {value: 'STEREO', name: gettext('Stereo')},
                                    {value: 'MONO', name: gettext('Mono')},
                                    {value: 'MONO_LEFT', name: gettext('Mono Left')},
                                    {value: 'MONO_RIGHT', name: gettext('Mono Right')},
                                    {value: 'LT_RT', name: 'Lt/Rt'}
                                ];

                            checkSelected(options, select);
                            callback(options);
                        },
                        prepareForSave: function ( value, callback ) {
                            var audioModes = {
                                STEREO: 0,
                                MONO: 1,
                                MONO_LEFT: 2,
                                MONO_RIGHT: 3,
                                LT_RT: 4
                            };

                            gSTB.SetStereoMode(audioModes[value]);
                            this.environment['audio_stereo_out_mode'] = value;
                            callback();
                        },
                        getter: api.getters.environment,
                        saver: api.savers.environment,
                        parent: 'audio'
                    },

                    //advanced
                    {
                        id: 'audioDRC',
                        name:  gettext('Dynamic range compression'),
                        description: '',
                        icon: 'theme-icon-volume',
                        render: api.renders.popupSelect,
                        saveImmediate: true,
                        advanced: true,
                        environment: {
                            'audio_dyn_range_comp': 'OFF'
                        },
                        prepareForRender: function ( environment, callback ) {
                            var select = environment['audio_dyn_range_comp'],
                                options = [
                                    {value: 'OFF', title: gettext('Disabled')},
                                    {value: '1', title: '1/8'},
                                    {value: '2', title: '2/8'},
                                    {value: '3', title: '3/8'},
                                    {value: '4', title: '4/8'},
                                    {value: '5', title: '5/8'},
                                    {value: '6', title: '6/8'},
                                    {value: '7', title: '7/8'},
                                    {value: 'MAX', title: gettext('Max')}
                                ];

                            checkSelected(options, select);
                            callback(options);
                        },
                        prepareForSave: function ( value, callback ) {
                            this.environment['audio_dyn_range_comp'] = value;

                            switch ( value ) {
                                case 'OFF':
                                    gSTB.SetDRC(0, 0);
                                    break;
                                case 'MAX':
                                    gSTB.SetDRC(255, 255);
                                    break;
                                default:
                                    value = parseInt(value, 10) * 31;
                                    gSTB.SetDRC(value, value);
                                    break;
                            }
                            callback();
                        },
                        getter: api.getters.environment,
                        saver: api.savers.environment,
                        parent: 'audio'
                    },
                    {
                        id: 'audioOpMode',
                        name:  gettext('Operating mode'),
                        description: '',
                        icon: 'theme-icon-volume',
                        render: api.renders.popupSelect,
                        saveImmediate: true,
                        advanced: true,
                        environment: {
                            'audio_operational_mode': 'RF_MODDE'
                        },
                        prepareForRender: function ( environment, callback ) {
                            var select = environment['audio_operational_mode'] || 'RF_MODDE',
                                options = [
                                    {value: 'RF_MODDE', name: 'RF Mode'},
                                    {value: 'LINE_MODE', name: 'Line Mode'},
                                    {value: 'CUSTOM0', name: 'Custom 0'},
                                    {value: 'CUSTOM1', name: 'Custom 1'}
                                ];

                            checkSelected(options, select);
                            callback(options);
                        },
                        prepareForSave: function ( value, callback ) {
                            var operatingModes = {
                                RF_MODDE: 0,
                                LINE_MODE: 1,
                                CUSTOM0: 2,
                                CUSTOM1: 3
                            };

                            this.environment['audio_operational_mode'] = value;

                            gSTB.SetAudioOperationalMode(operatingModes[value]);
                            callback();
                        },
                        getter: api.getters.environment,
                        saver: api.savers.environment,
                        parent: 'audio'
                    },
                    {
                        id: 'audioSPDIF',
                        name:  gettext('SPDIF Mode'),
                        description: '',
                        icon: 'theme-icon-volume',
                        render: api.renders.popupSelect,
                        saveImmediate: true,
                        advanced: true,
                        environment: {
                            'audio_spdif_mode': 'BITSTEAM'
                        },
                        prepareForRender: function ( environment, callback ) {
                            var select = environment['audio_spdif_mode'] || 'BITSTEAM',
                                options = [
                                    {value: 'PCM', name: 'PCM'},
                                    {value: 'BITSTEAM', name: 'Bitstream'}
                                ];

                            checkSelected(options, select);
                            callback(options);
                        },
                        prepareForSave: function ( value, callback ) {
                            this.environment['audio_spdif_mode'] = value;
                            gSTB.SetupSPdif(value === 'PCM' ? 1 : 2);
                            callback();
                        },
                        getter: api.getters.environment,
                        saver: api.savers.environment,
                        parent: 'audio'
                    },
                    {
                        id: 'audioHDMI',
                        name:  gettext('HDMI Audio'),
                        description: '',
                        icon: 'theme-icon-volume',
                        render: api.renders.popupSelect,
                        saveImmediate: true,
                        advanced: true,
                        environment: {
                            'audio_hdmi_audio_mode': 'PCM'
                        },
                        prepareForRender: function ( environment, callback ) {
                            var select = environment['audio_hdmi_audio_mode'] || 'PCM',
                                options = [
                                    {value: 'PCM', name: 'PCM'},
                                    {value: 'SPDIF', name: 'SPDIF'}
                                ];

                            checkSelected(options, select);
                            callback(options);
                        },
                        prepareForSave: function ( value, callback ) {
                            this.environment['audio_hdmi_audio_mode'] = value;
                            gSTB.SetHDMIAudioOut(value === 'SPDIF' ? 1 : 0);
                            callback();
                        },
                        getter: api.getters.environment,
                        saver: api.savers.environment,
                        parent: 'audio'
                    }
                ],
                content: []
            };
            break;
    }

    return data;
}

function setMute ( value ) {
    if ( mute !== value ) {
        mute = value;
        volumeWrapper.mute = mute;
        provider.emit('mute:change', {value: mute, system: true});
    }
}

function updateVolume () {
    var setValue = audioVolume + correctionReady;

    if ( setValue > 100 ) {
        setValue = 100;
    }
    if ( setValue < 0 ) {
        setValue = 0;
    }

    volumeWrapper.volume = setValue;
}

function setVolume ( value, manual ) {
    var old = audioVolume;

    audioVolume = value || value === 0 ? value : old;

    if ( audioVolume > 100 ) {
        audioVolume = 100;
    }
    if ( audioVolume < 0 ) {
        audioVolume = 0;
    }

    updateVolume();
    setMute(false);
    provider.emit('volume:change', {curr: audioVolume, prev: old, system: !manual});
}

if ( core.device.model !== 'AndroidSTB' && core.device.model !== 'emulator_stb' ) {
    core.addListener('keydown:' + keys.volumeUp, function () {
        audioVolume += step;
        setVolume(audioVolume);
    });

    core.addListener('keydown:' + keys.volumeDown, function () {
        audioVolume -= step;
        setVolume(audioVolume);
    });

    core.addListener('keydown:' + keys.mute, function () {
        setMute(!mute);
    });


    Object.defineProperties(
        provider,
        {
            volume: {
                get: function () {
                    return audioVolume;
                },
                set: function ( value ) {
                    setVolume(value, true);
                }
            },

            mute: {
                get: function () {
                    return mute;
                },
                set: function ( value ) {
                    setMute(value);
                }
            },

            correction: {
                get: function () {
                    return correction;
                },
                set: function ( value ) {
                    if ( value >= 100 || value <= -100 ) {
                        return false;
                    }

                    correction = value;
                    // use correction formula from wiki value = (correction * step / 10)
                    correctionReady = correction * step / 10;
                    updateVolume();

                    return correction;
                }
            }
        }
    );
}


module.exports = {
    onAppInit: function ( config, callback ) {
        callback(null, provider);
    },
    onInit: function ( config, callback ) {
        var needCheck = !top.MODE_PORTAL && !top.MODE_STALKER;

        if ( core.device.model !== 'AndroidSTB' && core.device.model !== 'emulator_stb' ) {
            if ( needCheck && volumeWrapper.volume ) {
                audioVolume = volumeWrapper.volume;
                mute = volumeWrapper.mute;
            } else {
                if ( core.environment.audio_initial_volume ) {
                    audioVolume = parseInt(core.environment.audio_initial_volume, 10) || 100;
                } else {
                    audioVolume = 100;
                }
                mute = false;
            }
            volumeWrapper.init(audioVolume, mute);
        }

        if ( callback ) {
            callback();
        }
    },
    onSettingsInit: function ( config, callback ) {
        api = config.api;
        gettextWrapper.load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            var data;

            gettext = gettextWrapper.gettext;
            data = buildList();

            callback(null, data);
        });
    }
};
